var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "ui-textarea-field ui-field ui-outline-field" },
    [
      _c("div", { staticClass: "ui-outline-field-wrapper" }, [
        _c(
          "textarea",
          {
            attrs: {
              id: `textarea-${_vm.id}`,
              required: !!_vm.required,
              rows: _vm.rows ? _vm.rows : 4,
              minlength: _vm.minlength,
            },
            on: {
              input: function ($event) {
                return _vm.$emit("input", $event.target.value)
              },
            },
          },
          [_vm._v(_vm._s(_vm.value))]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "ui-outline",
            attrs: { "data-label-lang": _vm.labelLang },
          },
          [
            _c("div", { staticClass: "ui-outline-left" }),
            _vm._v(" "),
            _c("div", { staticClass: "ui-outline-middle" }, [
              _c("label", { attrs: { for: `textarea-${_vm.id}` } }, [
                _vm._v("\n          " + _vm._s(_vm.label) + "\n          "),
                _vm.required
                  ? _c("span", { staticClass: "ui-field-required-marker" })
                  : _vm._e(),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "ui-outline-right" }),
          ]
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }